define.alias("shared/utils/string-formatters/snake-to-camel", "calendar/utils/string-formatters/snake-to-camel");